module.exports = __webpack_public_path__ + "static/media/fitness.d64c1bd5.jpg";